// The event's hero image on the public page. banner_mobile_url is the vertical 4:5 banner and
// background_img_url the wide one: a phone shows the first uncropped, every other width the wide one
// (a vertical image in the 250 px hero shows only a strip). Either one stands in for a missing other.
// The API also stores the strings "None" / "null" for an unset image.
const usable = (key?: string | null): string => {
  const v = (key ?? '').trim();
  return v === '' || /^(none|null|undefined)$/i.test(v) ? '' : v;
};

export interface EventHero {
  /** S3 key (or URL) to show, '' when the event has no image. */
  key: string;
  /** Show it whole at its own ratio (the vertical banner on a phone) instead of the 250 px crop. */
  full: boolean;
}

export const pickEventHero = (
  event: { banner_mobile_url?: string | null; background_img_url?: string | null },
  isPhone: boolean,
): EventHero => {
  const mobile = usable(event.banner_mobile_url);
  const wide = usable(event.background_img_url);
  if (isPhone && mobile) return { key: mobile, full: true };
  return { key: wide || mobile, full: false };
};
